export default __webpack_public_path__ + "static/media/empty-state.7f3fd0bd.svg";